"use client";

import { getApps, initializeApp, type FirebaseApp } from "firebase/app";
import { browserLocalPersistence, connectAuthEmulator, getAuth, initializeAuth, type Auth } from "firebase/auth";

export const alankarFirebaseConfig = {
  apiKey: "local-alankar-key",
  authDomain: "127.0.0.1",
  projectId: "alankar-local",
};

export function alankarAuthUrl() {
  if (typeof window !== "undefined" && window.location.origin) return window.location.origin;
  return "http://127.0.0.1:9099";
}

export function getAlankarAuth(): Auth {
  const app: FirebaseApp = getApps()[0] ?? initializeApp(alankarFirebaseConfig);
  try {
    const auth = initializeAuth(app, { persistence: browserLocalPersistence });
    connectAuthEmulator(auth, alankarAuthUrl(), { disableWarnings: true });
    return auth;
  } catch {
    return getAuth(app);
  }
}
